export const phoneAreaOptions = [
  { text: '台灣 (+886)', value: '+886' },
  { text: '中國 (+86)', value: '+86' },
  { text: '香港 (+852)', value: '+852' },
  { text: '澳門 (+853)', value: '+853' },
  { text: '新加坡 (+65)', value: '+65' }
]

export const countryAreaOptions = [
  '台灣', '中國', '香港', '澳門', '新加坡'
]

export const countryISOCode: { [key: string]: string } = {
  台灣: 'TW',
  中國: 'CN',
  香港: 'HK',
  澳門: 'MO',
  新加坡: 'SG'
}

export function getCountryCodeByPhoneCode (phoneCode: string): string | undefined {
  switch (phoneCode) {
    case '+886':
      return 'TW'
    case '+86':
      return 'CN'
    case '+852':
      return 'HK'
    case '+853':
      return 'MO'
    case '+65':
      return 'SG'
    default:
      return undefined
  }
}

export const nationIndexToPhoneCode = { 0: '+886', 1: '+86', 2: '+852', 3: '+853', 4: '+65' } as {
   [index: string]: string
}

export const phoneCodeToNationIndex = { '+886': 0, '+86': 1, '+852': 2, '+853': 3, '+65': 4 } as {
  [index: string]: number
}
